import React from "react";
import {Link} from "react-router-dom";
import SanitizedHTML from 'react-sanitized-html';
import slugify from 'slugify';
import {truncateString} from "../../utils/string";
import { timestampHumanizeFromNow, secondsToDuration, durationToDuration } from "../../utils/date";
import playIcon from '../../assets/img/icon/play-icon-white.svg';
import { useTranslation } from "react-i18next";
import he from 'he'


const WebResult = ({item})=>{
    return(
        <li>
            <div className="quiet fz13">
                <a className="link" href={`${item._source.scheme || 'https'}://${item._source.url}`}>
                    <span>{truncateString(`${item._source.scheme || 'https'}://${item._source.url.split('/').join(' › ')}`, 60)}</span>
                </a>
            </div>
            <h2 className="search-result-title">
                <a className="link" href={`${item._source.scheme || 'https'}://${item._source.url}`}>{truncateString(item._source.title, 70)}</a>
            </h2>
            <p className="quiet p">
                <SanitizedHTML
                  allowedTags={['strong']}
                  html={item.highlight && item.highlight.excerpt && item.highlight.excerpt[0] || item._source.excerpt}
                />
            </p>
        </li>
    )
}

export function WebResults({items}) {
    return (
        <ul className="news-list list divider md no-bullet">
            {
                items.map((item, index) =>(
                    <WebResult key={item._id} item={item}/>
                ))
            }
        </ul>
    );
}

const NewsResult = ({item})=>{
    return(
        <li>
            <div className="quiet fz13">
                <a className="link" href={`${item._source.scheme || 'https'}://${item._source.url}`}>
                    <span>{item._source.site_name}</span>
                </a>
            </div>
            <div className="media-box md">
                {item._source.image &&
                    <figure className="media right">
                        <a href={`${item._source.scheme || 'https'}://${item._source.url}`}>
                            <img src={item._source.image} width="439" height="328" alt="" />
                        </a>
                    </figure>
                }
              <div className="txt">
                <h2 className="search-result-title">
                    <a className="link" href={`${item._source.scheme || 'https'}://${item._source.url}`}>{truncateString(item._source.title, 70)}</a>
                </h2>
                <p className="quiet p">
                    <SanitizedHTML
                      allowedTags={['strong']}
                      html={item.highlight.excerpt && item.highlight.excerpt[0] || item._source.excerpt}
                    />
                </p>
                <div className="fz12 quiet">
                    <time>{timestampHumanizeFromNow(item._source.published_at / 1000)}</time>
                </div>
              </div>
            </div>
        </li>
    )
}

export function NewsResults({items}) {
    return (
        <ul className="news-list list divider md no-bullet">
            {
                items.map((item, index) =>(
                    <NewsResult key={item._id} item={item}/>
                ))
            }
        </ul>
    );
}

const BlogsResult = ({item})=>{
    return(
        <li>
            <div className="quiet fz13">
                {item._source.cm_url != undefined && item._source.cm_url != "" ? (
                        <a className="link" href={item._source.cm_url}>
                            <span>Crossmap Blogs</span>
                        </a>
                    ):(
                        <a className="link" href={`${item._source.scheme || 'https'}://${item._source.url}`}>
                            <span>{item._source.site_name}</span>
                        </a>
                    )
                }
            </div>
            <div className="media-box md">
                {item._source.image &&
                    <figure className="media right">
                        {item._source.cm_url != undefined && item._source.cm_url != "" ? (
                                <a href={item._source.cm_url}>
                                    <img src={item._source.image} width="439" height="328" alt="" />
                                </a>
                            ):(
                                <a href={`${item._source.scheme || 'https'}://${item._source.url}`}>
                                    <img src={item._source.image} width="439" height="328" alt="" />
                                </a>
                            )
                        }
                    </figure>
                }
              <div className="txt">
                <h2 className="search-result-title">
                    {item._source.cm_url != undefined && item._source.cm_url != "" ? (
                            <a className="link" href={item._source.cm_url}>{truncateString(item._source.title, 70)}</a>
                        ):(
                            <a className="link" href={`${item._source.scheme || 'https'}://${item._source.url}`}>{truncateString(item._source.title, 70)}</a>
                        )                    
                    }
                </h2>
                <p className="quiet p">
                    <SanitizedHTML
                      allowedTags={['strong']}
                      html={item.highlight.excerpt && item.highlight.excerpt[0] || item._source.excerpt}
                    />
                </p>
                <div className="fz12 quiet">
                    <time>{timestampHumanizeFromNow(item._source.published_at / 1000)}</time>
                </div>
              </div>
            </div>
        </li>
    )
}

export function BlogsResults({items}) {
    return (
        <ul className="news-list list divider md no-bullet">
            {
                items.map((item, index) =>(
                    <BlogsResult key={item._id} item={item}/>
                ))
            }
        </ul>
    );
}
const PodcastResult = ({item})=>{
    const epUrl = `https://podcasts.crossmap.com/episodes/${slugify(item.title)}/${item.id}`;
    const chUrl = `https://podcasts.crossmap.com/channels/${slugify(item.channel.title)}/${item.channel.id}`

    return(
        <li>
          <figure className="round-sm has-decor"><a href={epUrl}><img src={item.image ? item.image.base_url._240x240 : item.channel.image ? item.channel.image.base_url._240x240 : null} width="385" height="385" alt="" />
            <time className="decor location-br txt"><span>{secondsToDuration(item.duration)}</span></time>
          </a></figure>
          <h2 className="fz16 fwn spacing-sm"><a className="link" href={epUrl}>{item.title}</a></h2>
          <div className="quiet fz12">
            <a className="link mr-xs" href={chUrl}>{item.channel.title}</a>
            <time>{timestampHumanizeFromNow(item.published_at)}</time>
          </div>
        </li>
    )
}

export function PodcastResults({items}) {
    return (
        <div className="episode-list-wp">
          <ul className="episode-list no-bullet">
            {
                items.map((item, index) =>(
                    <PodcastResult key={item.id} item={item}/>
                ))
            }
          </ul>
        </div>
    );
}

const VideoResult = ({item})=>{
    const { t } = useTranslation();
    return(
        <li>
	    {/*<div className="quiet fz13"><a className="link" href={item._source.embed_link}> <span>{item._source.embed_link}</span></a></div>*/}
          <h2 className="search-result-title"><a className="link" href={item._source.embed_link}>{truncateString(item._source.title, 70)}</a></h2>
          <div className="media-box md">
            <figure className="media left has-decor"><a href={item._source.embed_link}><img src={item._source.thumbnail} width="160" height="90" alt=""></img>
              <span className="decor location-cc gap-re"><img src={playIcon} width="25" height="25" alt=""></img></span>
	      <time className="decor location-br gap-lg txt"><span>{durationToDuration(item._source.duration)}</span></time>
            </a></figure>
	    <div className="txt">
              <p className="quiet p">
	        {item.highlight && item.highlight.description ? (
		  <SanitizedHTML
                    allowedTags={['strong']}
                    html={item.highlight.description.join(' ')}
                  />
		):(
		  <SanitizedHTML
                    html={truncateString(item._source.description, 400)}
                  />
		)
		}
	      </p>
              <div className="fz12 quiet">
                <span>{t('item.uploaded_by')} &nbsp;
                  <a className="txt-primary link mr-sm" href={`https://youtube.com/channel/${item._source.channel.id}`}>{item._source.channel.title}</a>
                </span>
                <time className="mr-sm">{timestampHumanizeFromNow(item._source.published_at / 1000)}</time>
              </div>
            </div>
          </div>
        </li>
    )
}

export function VideoResults({items}) {
    return (
        <ul className="video-list list divider md no-bullet">
            {
                items.map((item, index) =>(
                    <VideoResult key={item._id} item={item}/>
                ))
            }
        </ul>
    );
}

const BookResult = ({item})=>{
    return(
        <li>
          <div className="media-box md">
	    {item._source.images.length > 0 &&
              <figure className="media left"><a href={"https://books.crossmap.com?p=" + item._source.cm_post_id}><img src={item._source.images[0].link} width="100" alt=""></img></a></figure>
	    }
            <div className="txt">
	    {/*<div className="quiet fz13"><a className="link" href={"https://books.crossmap.com?p=" + item._source.cm_post_id}>{"books.crossmap.com"}</a></div>*/}
              <h2 className="search-result-title"><a className="link" href={"https://books.crossmap.com?p=" + item._source.cm_post_id}>{he.decode(item._source.title)}</a></h2>
              <div className="fz12">
              </div>
            </div>
            <div className="book-description spacing-t-sm quiet">
	      <p>
	        {item.highlight.book_description ? (
		  <SanitizedHTML
                    allowedTags={['strong']}
                    html={item.highlight.book_description.join(' ')}
                  />
		):(
		  <SanitizedHTML
                    html={truncateString(item._source.book_description, 400)}
                  />
		)
		}
	      </p>
            </div>
          </div>
        </li>
    )
}

export function BookResults({items}) {
    return (
        <ul className="book-list list divider md no-bullet">
            {
                items.map((item, index) =>(
                    <BookResult key={item._id} item={item}/>
                ))
            }
        </ul>
    );
}

